import * as React from 'react';
import Svg, {ClipPath, Defs, G, Path} from 'react-native-svg';
import Styles from 'src/components/Styles';

function ViewPrivacyPolicy() {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none">
      <G clipPath="url(#clip0_5733_397)">
        <Path
          d="M12 4.737L5.566 7.465a.492.492 0 00-.316.45c.018 3.213 1.35 8.764 6.553 11.253.127.06.274.06.397 0 5.204-2.492 6.536-8.04 6.55-11.257a.501.501 0 00-.316-.45L12 4.737zm.471-1.635l6.62 2.809c.773.327 1.35 1.09 1.346 2.01-.017 3.488-1.451 9.87-7.509 12.77a2.147 2.147 0 01-1.856 0c-6.058-2.9-7.492-9.282-7.51-12.77-.003-.92.574-1.683 1.347-2.01l6.623-2.809a1.12 1.12 0 01.94 0z"
          fill={Styles.Colors.PayNew.black01}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_5733_397">
          <Path
            fill={Styles.white}
            transform="translate(3 3)"
            d="M0 0H18V18H0z"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

const ViewPrivacyPolicyIcon = React.memo(ViewPrivacyPolicy);

export default ViewPrivacyPolicyIcon;
